import PageInFlowWithSidebarLayout, {
  PageInFlowWithSidebarLayoutProps,
} from 'components/common/general/layouts/PageInFlowWithSidebarLayout';
import React from 'react';
import { observer } from 'mobx-react-lite';
import NavigationSidebar from 'components/user-settings/UserSettingsLayout/NavigationSidebar';
import { UserSettingsRouteV2Id } from 'routes/routesConfigV2';

interface UserSettingsLayoutProps
  extends Omit<PageInFlowWithSidebarLayoutProps, 'sidebar' | 'domainParams' | 'moreInfoBlob'> {
  pageId: UserSettingsRouteV2Id;
  isInitialLoading?: boolean;
}

const UserSettingsLayout: React.FC<UserSettingsLayoutProps> = observer(
  ({ pageId, isInitialLoading, pageHeader, ...rest }) => {
    return (
      <PageInFlowWithSidebarLayout
        domainParams={{}}
        pageId={pageId}
        sidebar={<NavigationSidebar pageId={pageId} />}
        isInitialLoading={isInitialLoading}
        pageHeader={{ onBackButtonClick: undefined, ...pageHeader }}
        {...rest}
      />
    );
  },
);

export default UserSettingsLayout;
